<template>
  <v-form class="ad-event__form">
    <label class="mb-1">ชื่อ Event สำหรับส่งไปให้ Facebook (ภาษาอังกฤษ) <span class="error--text">*</span></label>
    <v-text-field
      :value="'fb_mobile_purchase'"
      disabled
      outlined
      dense />
    <label class="mb-1">มูลค่า Event <span class="error--text">*</span></label>
    <v-text-field
      :value="'ยอดขาย'"
      disabled
      outlined
      dense />
    <label class="mb-1">สถานะออเดอร์ <span class="error--text">*</span></label>
    <v-text-field
      :value="'ทุกออเดอร์'"
      disabled
      outlined
      dense />
    <label class="mb-1">สำหรับเพจ <span class="error--text">*</span></label>
    <AdEventPageSelect
      :value="page"
      :items="pages"
      dense
      @input="$emit('update:page', $event)" />
  </v-form>
</template>

<script>
import { GET_FACEBOOKPAGES } from '@/resources/graphql'
import AdEventPageSelect from './AdEventPageSelect.vue'

export default {
  components: {
    AdEventPageSelect
  },
  props: {
    page: {
      type: Object,
      default: () => ({
        accessAllPage: true,
        pages: []
      })
    }
  },
  apollo: {
    pages: {
      query: GET_FACEBOOKPAGES,
      update (data) {
        const pages = data.me.facebookPages.nodes.map((item) => ({
          text: item.name,
          value: item.id,
          trackFbMobilePurchaseEvent: item.trackFbMobilePurchaseEvent
        }))
        return pages
      }
    }
  },
  data () {
    return {
      pages: []
    }
  }
}
</script>

<style lang="scss" scoped>
  .ad-event {
    &__form {
      ::v-deep {
        .v-input--is-disabled {
          fieldset {
            background-color: #E7E7E7;
          }
          input {
            color: var(--v-secondary-base);
          }
        }
      }
    }
  }
</style>
